import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeRoof: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home-roof, house"><path d="M12.4366 1.89017C12.1756 1.70328 11.8245 1.70328 11.5635 1.89017L2.06347 8.69136C1.72667 8.93248 1.64911 9.40098 1.89023 9.73778C2.13135 10.0746 2.59984 10.1521 2.93664 9.91102L4.00003 9.14973V20.25C4.00003 20.6642 4.33582 21 4.75003 21H19.25C19.6642 21 20 20.6642 20 20.25V9.14971L21.0634 9.91102C21.4002 10.1521 21.8687 10.0746 22.1099 9.73778C22.351 9.40098 22.2734 8.93248 21.9366 8.69136L12.4366 1.89017Z" fill="currentColor"/></CentralIconBase>;
};

export default IconHomeRoof;
